// 내 계정 API — /api/v2/auth/* 중 본인 계정 조작.
//
// 관리자가 남의 계정을 다루는 adminUsers.ts·storeStaff.ts 와 달리,
// 여기는 로그인한 본인이 자기 계정을 바꾸는 경로만 둔다 (티켓 #415).

import { authJson } from "./_client";
import { supabase } from "../lib/supabase";

const API_V2 = `${import.meta.env.VITE_API_BASE_URL ?? ""}/api/v2`;

type ChangePasswordResponse = {
  ok: boolean;
  session: { accessToken: string; refreshToken: string; expiresAt?: number } | null;
};

/**
 * 본인 비밀번호 변경. 지금 비밀번호가 틀리면 ApiError(payload.code="invalid_current_password").
 *
 * 서버가 비밀번호를 바꾸면 이 화면의 세션까지 폐기되므로, 응답에 실린 새 세션으로 갈아끼운다.
 * 새 세션을 못 받았거나 끼우지 못하면 false — 호출부는 "새 비밀번호로 다시 로그인"을 안내한다.
 */
export async function changeMyPassword(
  currentPassword: string,
  newPassword: string,
): Promise<{ sessionKept: boolean }> {
  const res = await authJson<ChangePasswordResponse>(`${API_V2}/auth/change-password`, {
    method: "POST",
    body: JSON.stringify({ currentPassword, newPassword }),
  });
  if (!res.session) return { sessionKept: false };
  const { error } = await supabase.auth.setSession({
    access_token: res.session.accessToken,
    refresh_token: res.session.refreshToken,
  });
  return { sessionKept: !error };
}
